import React from "react";
import { NavLink } from "react-router-dom";
import AgentAdded from "../../../Components/img/Thankyou_page_Image.jpg";

/**
 * Thank-you screens after onboarding is complete or already done.
 */
const VendorOnboardingThankYou = ({ flowComplete, accountData }) => {
  const isVendorDone =
    flowComplete ||
    (accountData.onboardfinal === "done" &&
      String(accountData.contactType || "").toLowerCase() === "vendor");

  if (isVendorDone) {
    return (
      <div className="thank_you row align-items-center mt-md-2">
        <div className="col-lg-7 order-lg-2 mb-lg-0 mb-4 pb-2 pb-lg-0 mt-lg-0 mt-md-0 mt-sm-5 mt-5">
          <img
            className="d-block mx-auto"
            src={AgentAdded}
            alt="Hero image"
          />
        </div>
        <div className="col-lg-5 order-lg-1 pe-lg-0">
          <h1 className="display-5 mb-4 me-lg-n5 text-lg-start text-center mb-4">
            Thank you
          </h1>
          <p className="text-lg-start text-center mb-4 mb-lg-5 fs-lg">
            Vendor profile created successfully. Awaiting admin approval.
          </p>
          <p className="text-lg-start text-center mb-4 mb-lg-5 fs-lg">
            You can sign in later to manage your listing once it is approved.
          </p>
          <div className="pull-right mt-2">
            <NavLink
              type="button"
              className="btn btn-primary btn-sm"
              to="/signin?vendor=1"
            >
              Go to login
            </NavLink>
          </div>
        </div>
      </div>
    );
  }

  if (accountData.onboardfinal === "done") {
    return (
      <div className="thank_you row align-items-center mt-md-2">
        <div className="col-lg-7 order-lg-2 mb-lg-0 mb-4 pb-2 pb-lg-0 mt-lg-0 mt-md-0 mt-sm-5 mt-5">
          <img
            className="d-block mx-auto"
            src={AgentAdded}
            alt="Hero image"
          />
        </div>
        <div className="col-lg-5 order-lg-1 pe-lg-0">
          <h1 className="display-5 mb-4 me-lg-n5 text-lg-start text-center mb-4">
            Thank you
          </h1>
          <p className="text-lg-start text-center mb-4 mb-lg-5 fs-lg">
            We are pleased to inform you that your account setup is already
            done. Our team at Indepth Realty will review your application, and
            upon approval, you will be notified via email.
          </p>
          <div className="pull-right mt-2">
            <NavLink type="button" className="btn btn-primary btn-sm" to="/">
              Go To Homepage
            </NavLink>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default VendorOnboardingThankYou;
